import { c as _c } from "react/compiler-runtime";
import { IcoClose24, IcoFootprintShield16, IcoLang16 } from '@onefootprint/icons';
import { cx } from 'class-variance-authority';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
type BifrostFrameProps = {
  children: ReactNode;
  /** For a preview whose parts the author clicks to select. */
  interactive?: boolean;
  /**
   * The frame is the editor, not a twin of it: its rows are the controls, so it stays in the tab
   * order; a dragged row is transformed past the card edge, so nothing may clip; and the children
   * own their padding, so a row's hover area reaches the edge.
   */
  editable?: boolean;
};
const BifrostFrame = t0 => {
  const $ = _c(45);
  const {
    children,
    interactive: t1,
    editable: t2
  } = t0;
  const interactive = t1 === undefined ? false : t1;
  const editable = t2 === undefined ? false : t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      keyPrefix: "nodePreview.footer"
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t3);
  const t4 = !interactive && !editable;
  const t5 = !editable;
  let t6;
  if ($[1] !== t5) {
    t6 = cx("w-full bg-primary rounded-md shadow-[0_2px_8px_rgba(0,0,0,0.1)]", {
      "overflow-hidden": t5
    });
    $[1] = t5;
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  let t7;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <header className="flex px-5 pt-4 pb-2"><IcoClose24 color="tertiary" /></header>;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  const t8 = editable ? undefined : "px-6 pb-6";
  let t9;
  if ($[4] !== children || $[5] !== t8) {
    t9 = <main className={t8}>{children}</main>;
    $[4] = children;
    $[5] = t8;
    $[6] = t9;
  } else {
    t9 = $[6];
  }
  let t10;
  if ($[7] !== editable) {
    t10 = cx("flex h-10 items-center justify-between px-4 bg-secondary border-t border-tertiary", {
      "rounded-b-md": editable
    });
    $[7] = editable;
    $[8] = t10;
  } else {
    t10 = $[8];
  }
  let t11;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <IcoFootprintShield16 color="secondary" />;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  let t12;
  if ($[10] !== t) {
    t12 = t(_temp);
    $[10] = t;
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  let t13;
  if ($[12] !== t12) {
    t13 = <div className="flex items-center gap-2 text-caption-1 text-secondary">{t11}{t12}</div>;
    $[12] = t12;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] !== t) {
    t14 = t(_temp2);
    $[14] = t;
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  let t15;
  if ($[16] !== t14) {
    t15 = <span>{t14}</span>;
    $[16] = t14;
    $[17] = t15;
  } else {
    t15 = $[17];
  }
  let t16;
  if ($[18] !== t) {
    t16 = t(_temp3);
    $[18] = t;
    $[19] = t16;
  } else {
    t16 = $[19];
  }
  let t17;
  if ($[20] !== t16) {
    t17 = <span>{t16}</span>;
    $[20] = t16;
    $[21] = t17;
  } else {
    t17 = $[21];
  }
  let t18;
  if ($[22] !== t) {
    t18 = t(_temp4);
    $[22] = t;
    $[23] = t18;
  } else {
    t18 = $[23];
  }
  let t19;
  if ($[24] !== t18) {
    t19 = <span>{t18}</span>;
    $[24] = t18;
    $[25] = t19;
  } else {
    t19 = $[25];
  }
  let t20;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <IcoLang16 color="secondary" />;
    $[26] = t20;
  } else {
    t20 = $[26];
  }
  let t21;
  if ($[27] !== t) {
    t21 = t(_temp5);
    $[27] = t;
    $[28] = t21;
  } else {
    t21 = $[28];
  }
  let t22;
  if ($[29] !== t21) {
    t22 = <span className="flex items-center gap-1">{t20}{t21}</span>;
    $[29] = t21;
    $[30] = t22;
  } else {
    t22 = $[30];
  }
  let t23;
  if ($[31] !== t15 || $[32] !== t17 || $[33] !== t19 || $[34] !== t22) {
    t23 = <div className="flex items-center gap-3 text-caption-1 text-secondary">{t15}{t17}{t19}{t22}</div>;
    $[31] = t15;
    $[32] = t17;
    $[33] = t19;
    $[34] = t22;
    $[35] = t23;
  } else {
    t23 = $[35];
  }
  let t24;
  if ($[36] !== t10 || $[37] !== t13 || $[38] !== t23) {
    t24 = <footer className={t10}>{t13}{t23}</footer>;
    $[36] = t10;
    $[37] = t13;
    $[38] = t23;
    $[39] = t24;
  } else {
    t24 = $[39];
  }
  let t25;
  if ($[40] !== t24 || $[41] !== t4 || $[42] !== t6 || $[43] !== t9) {
    t25 = <div inert={t4} className={t6}>{t7}{t9}{t24}</div>;
    $[40] = t24;
    $[41] = t4;
    $[42] = t6;
    $[43] = t9;
    $[44] = t25;
  } else {
    t25 = $[44];
  }
  return t25;
};
export default BifrostFrame;
export type { BifrostFrameProps };
function _temp($) {
  return $.securedByFootprint;
}
function _temp2($_0) {
  return $_0.support;
}
function _temp3($_1) {
  return $_1.privacy;
}
function _temp4($_2) {
  return $_2.terms;
}
function _temp5($_3) {
  return $_3.language;
}